export const DOOR_HEIGHT_LIMIT = 150;
export const BOTTOM_LABELLING_LIMIT_PERCENT = 15;
export const DOOR_ANNOTATION_NOT_VALID_WARNING_MESSAGE =
  'This door might not meet specifications. Please contact support for more details';
